/**
 * track-help-dialog.js
 */

import React from 'react';
import { Link } from '@mui/material';
import { useTranslation, Trans } from 'react-i18next';
import { LiveTrackingContext } from './live-tracking-context';
import { TrackingFormContext } from './tracking-form-context';
import Icon from 'components/icon';
import HelpDialog from 'components/help-dialog';


export default function TrackHelpDialog(props) {
  const { trackType } = React.useContext(TrackingFormContext);
  const { isTrackHelpOpen, setIsTrackHelpOpen } = React.useContext(LiveTrackingContext);
  const translationNamespace = trackType
    ? `tracking${trackType.charAt(0).toUpperCase() + trackType.slice(1)}`
    : undefined;
  const { t, i18n } = useTranslation(translationNamespace);

  if (!trackType) {
    return null;
  }

  const resourceBundle = i18n.getResourceBundle(i18n.language, translationNamespace);
  const sectionObj = resourceBundle.help;
  const helpTitle = sectionObj.sectionName;
  const helpFieldList = Object
    .entries(sectionObj)
    .filter(([key, val]) => key !== 'sectionName' && val.helpInfo)
    .map(([key, val]) => [
      key,
      {
        ...val,
        helpInfo: <Trans
          t={t}
          components={{
            ol: <ol />,
            ul: <ul />,
            li: <li />,
            a: <Link />,
            cameraMarkerIcon: <Icon type='camera-marker' fontSize='small' style={{ verticalAlign: 'text-bottom' }} />,
            locationAddIcon: <Icon type='location-add' fontSize='small' style={{ verticalAlign: 'text-bottom' }} />,
          }}
        >
          {val.helpInfo}
        </Trans>
      }
    ]);

  return (
    <HelpDialog
      open={isTrackHelpOpen}
      onClose={() => setIsTrackHelpOpen(false)}
      title={helpTitle}
      iconName={`track-${trackType}`}
      helpFieldList={helpFieldList}
    />
  );
}